import Header from '@/components/header/index.vue';
import Search from '@/components/search/index.vue';
import Menu from '@/components/menu/index.vue';
import Bottom from '@/components/bottom/index.vue';
import ProcessNavigation from '@/components/process-navigation/index.vue';
import { errorMessage } from '@/utils/message.js';
const debounce = require('lodash.debounce');
import { mapGetters } from 'vuex';

import Service from '@/service/index.js';
import PublishProjectService from '../publish-project-service.js';

export default {
  components: {
    Header,
    Search,
    Menu,
    Bottom,
    ProcessNavigation
  },
  data() {
    return {
      // processList: ['业务流程及准备材料', '编辑项目信息', '编辑受让资格', '上传附件信息', '重大事项提示', '承诺信息', '提交申请'],
      step: 5,
      id: '',
      oldId: '',
      // tradeType: '',
      isCreated: true,
      ruleForm: {
        promiseHit: '',
        promiseHitOther: '',
        subjectMortgage: '',
        subjectTitleCertificateSituation: ''
      },
      isAgree: false,
      submitStatus: 'init',
      conditionList: {},
      // text: '瑕疵声明及重大事项提示',
      text: '瑕疵声明',
      projectType: 1, // 项目类型
      projectSubType: 1, // 项目子类

      subjectMortgageList: [],
      subjectTitleList: [],
      rules: {
        promiseHit: [
          { required: true, message: '请输入各种补贴的约定，不超过200字', trigger: 'blur' }
        ],
        subjectMortgage: [
          { required: true, message: '请选择标的抵押情况', trigger: 'change' }
        ],
        subjectTitleCertificateSituation: [
          { required: true, message: '请选择标的产权证情况', trigger: 'change' }
        ]
      },
      textOtherPlaceholder: '请输入提示信息，不超过1000字'
    };
  },
  computed: {
    ...mapGetters([
      'processList',
      'tradeType'
    ])
  },
  created () {
    window.scrollTo(0, 0);
    // this.tradeType = this.$route.query.tradeType;
    this.projectType = this.$route.query.projectType; // 项目类型
    this.projectSubType = this.$route.query.projectSubType; // 项目子类
    // if (this.tradeType === '2') {
    //   this.processList = ['业务流程及准备材料', '编辑项目信息', '上传附件信息', '重大事项提示', '承诺信息', '提交申请'];
    //   this.step = 4;
    // }
    // if((Number(this.projectType) === 1 || Number(this.projectType) === 7) && Number(this.projectSubType) === 2 || Number(this.projectType) === 4){
    //   this.text = '瑕疵声明';
    // }
    if(Number(this.projectType) === 3) {
      this.textOtherPlaceholder = '请输入季节灌溉、汛期放水、涉及补贴等约定和标的有无政府部门颁发的权属证书？是否存在抵押、查封、征占等情况';
    }
    if(Number(this.projectType) === 8) {
      this.textOtherPlaceholder = '请输入使用用途要求、是否允许装修改造、是否可以转包(转祖)、是否需要交纳定(押)金、消防安全要求,以及水面经营权关于季节灌溉、汛期放水等要求、相关费用约定等,不超过1000字';
    }
    this.id = this.$route.query.id;
    this.oldId = this.$route.query.oldId;
    if (this.id) {
      this.getNewsCommitmentInfo().then(() => {}, () => {
        if (this.oldId) {
          this.getOldCommitmentInfo();
        }
      });
    }
    const arr = [
      ['subjectMortgageList', 'SUBJECT_MORTGAGE'],
      ['subjectTitleList', 'SUBJECT_TITLE_CERTIFICATE_SITUATION']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = res.data;
        }
      });
    });

    this.conditionList = {
      '1-1': [
        '1.标的面积与实测面积若有差异，不调整标的发包价格。',
        '2.标的以实际状况为准，交易市场及转让方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向受让方参考，不构成任何担保。',
        '3.意向受让方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向受让方交纳了竞价保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。',
        '4.标的无政府部门颁发的相关权属证书。'
      ],
      '1-2': [
        '1.标的面积与实测面积若有差异，不调整标的流转价格。',
        '2.标的以实际状况为准，交易市场及转让方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向受让方参考，不构成任何担保。',
        '3.意向受让方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向受让方交纳了竞价保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。'
      ],
      '2-1': [
        '1.标的面积与实测面积若有差异，不调整标的发包价格。',
        '2.标的以实际状况为准，农村产权交易市场及转让方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向受让方参考，不构成任何担保。',
        '3.意向受让方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向受让方交纳了保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。',
        '4.标的无政府部门颁发的相关权属证书。'
      ],
      '2-2': [
        '1.标的面积与实测面积若有差异，不调整标的发包价格。',
        '2.标的以实际状况为准，农村产权交易市场及转让方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向受让方参考，不构成任何担保。',
        '3.意向受让方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向受让方交纳了保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。',
        '4.标的无政府部门颁发的相关权属证书。'
      ],
      '2-3': [
        '1.标的与实际情况若有差异，不调整标的转让价格。',
        '2.标的以实际状况为准，交易市场及转让方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向受让方参考，不构成任何担保。',
        '3.意向受让方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向受让方交纳了竞价保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。',
        '4.受让方自行承担标的交接、装运、使用所产生的费用，以及相应的安全环保事故责任。'
      ],
      '3-1': [
        '1.标的面积为估计面积，可能因为季节和自然条件等发生变化，与实际面积若有差异，不调整标的发包价格。',
        '2.标的以实际状况为准，农村产权交易市场及转让方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向受让方参考，不构成任何担保。',
        '3.意向受让方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向受让方交纳了保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。',
        '4.发包期限内，标的所发生的任何费用均由受让方承担。',
        '5.标的用途不得更改，受让方在经营过程中，应符合环保、水务、畜牧、水产等有关法律法规政策要求。',
        '6.受让方对附属设施等有管护责任，新建设施应征得转让方同意。'
      ],
      '4-1': [
        '1.标的面积与实测面积若有差异，不调整标的发包价格。',
        '2.标的以实际状况为准，农村产权交易市场及转让方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向受让方参考，不构成任何担保。',
        '3.意向受让方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向受让方交纳了保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。',
        '4.标的无政府部门颁发的相关权属证书。'
      ],
      '4-2': [
        '1.标的面积与实测面积若有差异，不调整标的发包价格。',
        '2.标的以实际状况为准，农村产权交易市场及转让方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向受让方参考，不构成任何担保。',
        '3.意向受让方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向受让方交纳了保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。',
        '4.标的无政府部门颁发的相关权属证书。'
      ],
      '4-3': [
        '1.标的面积与实测面积若有差异，不调整标的发包价格。',
        '2.标的以实际状况为准，农村产权交易市场及转让方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向受让方参考，不构成任何担保。',
        '3.意向受让方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向受让方交纳了保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。',
        '4.标的无政府部门颁发的相关权属证书。'
      ],
      '4-4': [
        '1.标的面积与实测面积若有差异，不调整标的发包价格。',
        '2.标的以实际状况为准，农村产权交易市场及转让方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向受让方参考，不构成任何担保。',
        '3.意向受让方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向受让方交纳了保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。',
        '4.标的无政府部门颁发的相关权属证书。'
      ],
      '6-1': [
        '1.标的面积等与实际情况若有差异，不调整标的出租价格。',
        '2.标的以实际状况为准，交易市场及出租方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向承租方参考，不构成任何担保。',
        '3.意向承租方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向承租方交纳了竞价保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。'
      ],
      '6-2': [
        '1.标的面积等与实际情况若有差异，不调整标的出租价格。',
        '2.标的以实际状况为准，交易市场及出租方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向承租方参考，不构成任何担保。',
        '3.意向承租方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向承租方交纳了竞价保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。'
      ],
      '6-3': [
        '1.标的面积等与实际情况若有差异，不调整标的出租价格。',
        '2.标的以实际状况为准，交易市场及出租方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向承租方参考，不构成任何担保。',
        '3.意向承租方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向承租方交纳了竞价保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。'
      ],
      '7-1': [
        '1.标的与实际情况若有差异，不调整标的转让价格。',
        '2.标的以实际状况为准，交易市场及转让方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向受让方参考，不构成任何担保。',
        '3.意向受让方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向受让方交纳了竞价保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。',
        '4.受让方自行承担标的交接、装运、使用所产生的费用，以及相应的安全环保事故责任。'
      ],
      '7-2': [
        '1.标的与实际情况若有差异，不调整标的出租价格。',
        '2.标的以实际状况为准，交易市场及转让方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向承租方参考，不构成任何担保。',
        '3.意向承租方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向承租方交纳了竞价保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。',
        '4.承租方自行承担标的交接、装运、使用所产生的费用，以及相应的安全环保事故责任。'
      ],
      '7-3': [
        '1.标的与实际情况若有差异，不调整标的出租价格。',
        '2.标的以实际状况为准，交易市场及转让方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向承租方参考，不构成任何担保。',
        '3.意向承租方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向承租方交纳了竞价保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。',
        '4.承租方自行承担标的交接、装运、使用所产生的费用，以及相应的安全环保事故责任。'
      ],
      '8-1': [
        '1.标的与实际情况若有差异，不调整标的交易价格。',
        '2.标的以实际状况为准，交易市场及转让方不承担任何瑕疵担保责任，无论采用何种方式介绍和评价，仅供意向受让方参考，不构成任何担保。',
        '3.意向受让方有义务了解和查验交易标的，对可能存在的瑕疵作全面审查和勘验, 或聘请专业人员鉴定。意向受让方交纳了竞价保证金，即表明接受该标的的一切现状(包括缺陷)，愿意承担一切风险和责任。',
        '4.受让方承担标的交接、装运、使用所产生的一切费用，以及相应的安全环保事故责任。',
        '5.受让方在经营过程中，应符合有关法律法规政策要求。',
        '6.受让方对地上附着物、附属设施等有管护责任，新建设施应征得所有权人同意。'
      ]
    };
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs['commitmentForm'].resetFields();
    });
  },
  methods: {
    getNewsCommitmentInfo () {
      return new Promise((resolve, reject) => {
        PublishProjectService.getProjectInfo({
          projectId: this.id,
          echoCode: 'PROMISE'
        }).then(res => {
          if (!res.data) {
            reject();
          } else {
            this.isCreated = false;
            // this.ruleForm = res.data;
            if(res.data) {
              this.ruleForm.promiseHit = res.data.promiseHit;
              this.ruleForm.promiseHitOther = res.data.promiseHitOther;

              this.ruleForm.subjectMortgage = res.data.subjectMortgage && String(res.data.subjectMortgage);
              this.ruleForm.subjectTitleCertificateSituation = res.data.subjectTitleCertificateSituation && String(res.data.subjectTitleCertificateSituation);
            }
            resolve();
          }
        });
      });
    },
    getOldCommitmentInfo () {
      PublishProjectService.getProjectInfo({
        projectId: this.oldId,
        echoCode: 'PROMISE'
      }).then(res => {
        if (!res.data) {
          return;
        }
        this.isCreated = true;

        // this.ruleForm = res.data;
        this.ruleForm.promiseHit = res.data && res.data.promiseHit;
        this.ruleForm.promiseHitOther = res.data && res.data.promiseHitOther;

        this.ruleForm.subjectMortgage = res.data && String(res.data.subjectMortgage);
        this.ruleForm.subjectTitleCertificateSituation = res.data && String(res.data.subjectTitleCertificateSituation);
      });
    },
    previousStep () {
      this.$router.back();
    },
    next: debounce(function(){
      if (this.submitStatus === 'ongoing') {return;}
      this.$refs['commitmentForm'].validate(valid => {
        if (valid) {
          this.submitStatus = 'ongoing';
          if (this.isCreated) {
            PublishProjectService.saveCommitmentInfo({
              projectId: this.id,
              ...this.ruleForm
            }).then(res => {
              if (res && res.code === '0') {
                this.submitStatus = 'success';
                // this.$router.push('/publish-project/commitment-text?tradeType=' + this.tradeType + '&id=' + this.id + '&projectType=' + this.projectType);
                this.$router.push({ path: '/publish-project/commitment-text', query: {
                  id: this.id,
                  tradeType: this.tradeType,
                  projectType: this.projectType,
                  projectSubType: this.projectSubType
                }});
              } else if (res && res.reason) {
                errorMessage(res && res.reason);
                this.submitStatus = 'failed';
              } else {
                errorMessage('保存重大事项提示失败');
                this.submitStatus = 'failed';
              }
            }, (error) => {
              this.submitStatus = 'failed';
              if (error && error.data && error.data.reason) {
                errorMessage(error.data.reason);
              } else {
                errorMessage('保存重大事项提示失败');
              }
            });
          } else {
            PublishProjectService.updateCommitmentInfo({
              projectId: this.id,
              ...this.ruleForm
            }).then(res => {
              if (res && res.code === '0') {
                this.submitStatus = 'success';
                // this.$router.push('/publish-project/commitment-text?tradeType=' + this.tradeType + '&id=' + this.id + '&projectType=' + this.projectType);
                this.$router.push({ path: '/publish-project/commitment-text', query: {
                  id: this.id,
                  tradeType: this.tradeType,
                  projectType: this.projectType,
                  projectSubType: this.projectSubType
                }});
              } else if (res && res.reason) {
                errorMessage(res && res.reason);
                this.submitStatus = 'failed';
              } else {
                errorMessage('保存重大事项提示失败');
                this.submitStatus = 'failed';
              }
            }, (error) => {
              this.submitStatus = 'failed';
              if (error && error.data && error.data.reason) {
                errorMessage(error.data.reason);
              } else {
                errorMessage('保存重大事项提示失败');
              }
            });
          }
        } else {
          return false;
        }
      });
    }, 2000, {
      'leading': true,
      'trailing': false
    })
  }
};
